module.exports = __webpack_public_path__ + "img/park_hover_455ba31.webp";